import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import TopBanner from "./TopBanner";
import Header from "./Header";
import Footer from "./Footer";
import AssistantWidget from "@/components/common/AssistantWidget";
import { LocalBusinessJsonLd } from "@/components/common/Seo";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <LocalBusinessJsonLd />
      <TopBanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AssistantWidget />
    </div>
  );
}
